const REPLACEMENT_STRING = '<REPLACEMENT_STRING>';
const PERIOD = '.';

export const sanitizeFormKey = (key: string) =>
  key.replaceAll(PERIOD, REPLACEMENT_STRING);

export const originalFormKey = (key: string) =>
  key.replaceAll(REPLACEMENT_STRING, PERIOD);
